import React from 'react';
import {Checkbox, Switch} from 'antd';
import {WeaSearchGroup, WeaFormItem, WeaColorPicker, WeaSelect } from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import ELinkMode from './base/ELinkMode';

// 个人数据
export default class Content_DataCenter extends React.Component {
    state = {
        eSyncContent: this.props.eSyncContent,
        eSyncContentAll: false,
        eContentShowType: this.props.eContentShowType || '0',
        eShowContent4Person: this.props.eShowContent4Person
    };

    render() {
        const {eSyncContent, eSyncContentAll, eShowContent4Person} = this.state;

        let ESyncContent = <div></div>;
        if (this.props.eShareLevel == '2' && !!eSyncContent) {
            ESyncContent = (
                <WeaFormItem label={getLabel(32328, '同步内容')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <Switch size="small" checked={eSyncContentAll} onChange={checked => this.setState({eSyncContentAll: checked})}/>
                </WeaFormItem>
            );
        }

        let eShowContent4PersonList = [];
        for (let key in eShowContent4Person) {
            if (eShowContent4Person.hasOwnProperty(key)) {
                eShowContent4PersonList.push(
                    <li style={{height: '35px'}}>
                        <div style={{width: 120,
                            display: "inline-block"}}>
                        <Checkbox
                            size="default"
                            checked={eShowContent4Person[key].checked}
                            onChange={
                                e => this.setState({
                                    eShowContent4Person: {
                                        ...eShowContent4Person, [key]: {...eShowContent4Person[key], checked: e.target.checked}
                                    }
                                })
                            }
                        >
                            {eShowContent4Person[key].label}
                        </Checkbox>
                        </div>
                        <WeaColorPicker
                            value={eShowContent4Person[key].color}
                            onChange={
                                (value) => this.setState({
                                    eShowContent4Person: {
                                        ...eShowContent4Person, [key]: {...eShowContent4Person[key], color: value}
                                    }
                                })
                            }
                        />
                    </li>
                );
            }
        }

        let EShowContent4Person = (
            <WeaFormItem label={getLabel(15935, '显示内容')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <ul ref="eShowContent4Person">
                    {eShowContent4PersonList}
                </ul>
            </WeaFormItem>
        );

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                    <WeaFormItem label={'展现方式'} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaSelect
                            options={[
                                {
                                    key: "0",
                                    showname: "图标"
                                },{
                                    key: "1",
                                    showname: "内容文字"
                                }
                            ]}
                            value={this.state.eContentShowType}
                            detailtype={3}
                            onChange={value => {
                                this.setState({eContentShowType: value});
                            }}
                        />
                    </WeaFormItem>
                    {ESyncContent}
                    {EShowContent4Person}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentSync: this.state.eSyncContent,
            eContentShowType: this.state.eContentShowType,
            eContentSyncAll: this.state.eSyncContentAll,
            eContentShow: this.state.eShowContent4Person
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_DataCenter.js